import { useContext } from 'react';
import { DECKS } from '../constants/decks';
import type { DeckDefinition } from '../../types/deck';
import { DeckContext } from './deck-context';

/** Access the active-deck state. Must be used beneath a `DeckProvider`. */
export function useDeck() {
    const ctx = useContext(DeckContext);
    if (!ctx) throw new Error('useDeck must be used within a DeckProvider');
    return ctx;
}

/** The active deck's full definition (images, text, header copy). */
export function useActiveDeck(): DeckDefinition {
    const { deckId } = useDeck();
    return DECKS[deckId];
}
